/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { memo } from 'react'
import Img from './Img'

interface DueDateIndicatorProps {
  dueDateStatus?: string | null
  translate: (key: string) => string
}

interface IndicatorConfig {
  src: string
  alt: string
}

const DueDateIndicator: React.FC<DueDateIndicatorProps> = memo(({ dueDateStatus, translate }) => {
  if (!dueDateStatus || dueDateStatus === 'ON_TRACK') {
    return null
  }

  const getIndicatorConfig = (status: string): IndicatorConfig | null => {
    switch (status) {
      case 'OVERDUE':
        return {
          src: '/assets/images/status-overdue.svg',
          alt: translate('DUE_DATE_OVERDUE')
        }
      case 'DUE_SOON':
        return {
          src: '/assets/images/status-due-soon.svg',
          alt: translate('DUE_DATE_DUE_SOON')
        }
      default:
        return null
    }
  }

  const config = getIndicatorConfig(dueDateStatus)

  // Early return if no valid config
  if (!config) return null

  return (
    <Img
      src={config.src}
      alt={config.alt}
      title={config.alt}
      style={{
        display: 'inline-block',
        marginLeft: '8px',
        verticalAlign: 'middle',
        height: '20px'
      }}
    />
  )
})

// Set display name for debugging
DueDateIndicator.displayName = 'DueDateIndicator'

export default DueDateIndicator
